import React, { FunctionComponent } from "react";
import {
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  Stack,
} from "@mui/material";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import { CustomInput } from "../../../CustomInput";
import { Button } from "../../../Button";
import { ISectionProps } from "../ISectionProps";
import { ICompanyInfoState } from "../../IState";
import { IProps } from "./IProps";
import { NewInputDialog } from "../NewInputDialog";
import { useNewInput } from "../../new-input.hook";
import { User } from "../../../../model/User";

export const CompanyInfo: FunctionComponent<
  ISectionProps<ICompanyInfoState> & IProps
> = (props) => {
  const {
    data,
    onChange,
    disableFieldsForDealers,
    disableReadForm,
    onChangeCheckbox,
    onPauseLead,
  } = props;

  const { isNewInputDialogOpen, toggleNewInputDialog } = useNewInput();

  const user = new User();

  return (
    <Box width="100%" p={0.4} ml={1} mt={2}>
      <Typography display="inline" sx={{ color: "#1BA0E9", fontWeight: 600, fontSize: 18 }}>
        Company Info 
      </Typography> 
      <Typography display="inline" sx={{ fontSize: 16, fontWeight: 600 }}>
            { user.SecLevel > 1 && (props.isDealer ? " (Dealer)" : " (Admin)" )}
      </Typography>      
      <Box
        mt={2}
        sx={{ gap: 2, display: "flex", width: "100%", flexWrap: "wrap" }}
      >
        <CustomInput
          disabled={disableReadForm || disableFieldsForDealers()}
          value={data.companyName}
          width={320}
          height={35}
          label={{ text: "Company Name", color: "rgba(0, 0, 0, 0.8)" }}
          name="companyName"
          placeholder="company name"
          readOnly={props.disableFieldsForDealers()}
          onChange={onChange}
        />
        <CustomInput
          disabled={props.disableReadForm}
          value={data.contactPhone}
          width={320}
          height={35}
          label={{ text: "Contact Phone", color: "rgba(0, 0, 0, 0.8)" }}
          name="contactPhone"
          placeholder="contact phone"
          onChange={onChange}
        />
        <CustomInput
          disabled={props.disableReadForm}
          value={data.phoneLeadCCEmail}
          width={320}
          height={35}
          label={{ text: "Phone Lead CC Email", color: "rgba(0, 0, 0, 0.8)" }}
          name="phoneLeadCCEmail"
          placeholder="phone lead cc email"
          onChange={onChange}
        />
        <CustomInput
          disabled={props.disableReadForm}
          value={data.internetLeadCCEmail}
          width={320}
          height={35}
          label={{
            text: "Internet Lead CC Email",
            color: "rgba(0, 0, 0, 0.8)",
          }}
          name="internetLeadCCEmail"
          placeholder="internet lead cc email"
          onChange={onChange}
        />
        <CustomInput
          disabled={props.disableReadForm}
          value={data.primaryContact}
          width={320}
          height={35}
          label={{ text: "Primary Contact", color: "rgba(0, 0, 0, 0.8)" }}
          name="primaryContact"
          placeholder="primay contact"
          onChange={onChange}
        />
        <CustomInput
          disabled={props.disableReadForm}
          value={data.phoneLeadEmailAddress}
          width={320}
          height={35}
          label={{
            text: "Phone Lead Email Address",
            color: "rgba(0, 0, 0, 0.8)",
          }}
          name="phoneLeadEmailAddress"
          placeholder="phone lead email address"
          onChange={onChange}
        />
        <CustomInput
          disabled={props.disableReadForm}
          value={data.internetLeadEmail}
          width={320}
          height={35}
          label={{ text: "Internet Lead Email", color: "rgba(0, 0, 0, 0.8)" }}
          name="internetLeadEmail"
          placeholder="internet lead email"
        />
      </Box>
      <FormControlLabel
        disabled={props.disableReadForm}
        sx={{ my: 2 }}
        control={
          <Checkbox
            onChange={onChangeCheckbox}
            checked={data.sendEmail}
            sx={{ color: "#1BA0E9" }}
            icon={<RadioButtonUncheckedIcon />}
            checkedIcon={<RadioButtonCheckedIcon sx={{ color: "#1BA0E9" }} />}
          />
        }
        label={
          <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
            Send Email For Each Lead
          </Typography>
        }
      />
      <Box mt={2} sx={{ gap: 2, pb: 4 }}>
        {user.SecLevel > 1 && props.isDealer && (
          <Button
            isLoading={props.pauseLoading}
            height={35}
            label={data.isLeadPaused ? "Resume Leads" : "Pause Leads"}
            onClick={props.onPauseLead}
          />
        )}
      </Box>
    </Box>
  );
};
